interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/1b77b62f-3787-44d3-a822-0a6da43397f6.png" 
              alt="SALINAS S.R.L. Logo" 
              className="h-10 w-auto"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-[#1A1F36]' : 'text-white'}`}>
              SALINAS S.R.L.
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors hover:text-[#00D4AA] whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors hover:text-[#00D4AA] whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('vpn-service')}
              className={`font-medium transition-colors hover:text-[#00D4AA] whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              VPN Service
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`font-medium transition-colors hover:text-[#00D4AA] whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors hover:text-[#00D4AA] whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-[#00D4AA] text-white px-6 py-2.5 rounded-full font-medium hover:bg-[#00BF99] transition-all whitespace-nowrap"
          >
            Get Started
          </button>

          <button className="md:hidden text-white">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-[#1A1F36]' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
